module.exports = __webpack_public_path__ + "resources/img/img-deep-security-02-1.65194f7914f22d3cca3208bbd512d27c.png";